<template>
  <div id="analytics-sale-manager">
    <el-card style="box-shadow: 2px 2px #c7c7c7;">
      <div class="row">
        <div class="col-md-4 d-flex align-items-center mb-3">
          <div style="width: 40px;"><span class="mr-2">期間</span></div>
          <el-date-picker
              v-model="dateStart"
              type="date"
              class="search-date"
              @change="checkFilterData"
              :picker-options="{disabledDate: disableFutureDates, firstDayOfWeek: startWeekday}"
              placeholder="2022/01/01">
          </el-date-picker>
          <span class="mx-2">~</span>
          <el-date-picker
              v-model="dateEnd"
              type="date"
              class="search-date"
              :picker-options="{disabledDate: disableFutureDates, firstDayOfWeek: startWeekday}"
              @change="checkFilterData"
              placeholder="2022/02/01">
          </el-date-picker>
        </div>
        <div class="col-md-4 d-flex align-items-center mb-3">
          <div class="mr-2">フォロー担当</div>
          <el-select v-model="valueCustomer"
                     @change="checkFilterData">
            <el-option
                v-for="item in therapists"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-4 d-flex align-items-center mb-3">
          <div class="mr-2">年齢</div>
          <el-select v-model="valueAge"
                     @change="checkFilterData"
          >
            <el-option
                v-for="item in ageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </el-card>
    <div class="title">リピート率</div>
    <el-card class="shadow-bottom-right">
      <div class="row">
          <div class="col-md-12">
            <div v-if="(repeat_chart.percent_repeats || []).length < 1">データなし</div>
            <div v-else><RepeatLinenChart ref="lineChart" :height="250" /></div>
            <loading :active.sync="repeat_chart.isLoading" :is-full-page="fullPage" :color="color"
            :opacity="opacity"></loading>
          </div>
      </div>
    </el-card>
    <div class="mt-4">
      <div class="d-flex">
        <div style="width: 100px; margin-right: 30px">
          <el-card class="shadow-bottom-right card-number-repeat">
            <div style="padding: 0 20px">
              <div class="divider">来院回数</div>
            </div>
            <div class="text-number-repeat" v-for="(item, index) in numberRepeat"
                 :key="index"
                 :class="{ active: item.active }"
                 @click="selectNumberRepeat(index)">
              {{item.label}}
            </div>
          </el-card>
        </div>
        <div style="width: calc(100% - 130px )">
          <el-card style="box-shadow: 2px 2px #c7c7c7">
            <div class="col-md-4 p-3">
              <div style="border: 1px solid #c1c1c1; border-radius: 8px;">
                <div class="p-2 title-card-2">顧客数</div>
                <div class="p-4 text-center text-card2-top" v-if="customerVisted == null || customerVisted == '' || customerVisted == 0">-</div>
                <div class="p-4 text-center text-card2-top" v-else>{{ customerVisted }}名</div>
              </div>
            </div>
            <div class="col-md-4 p-3">
              <div style="border: 1px solid #c1c1c1; border-radius: 8px;">
                <div class="p-2 title-card-2" >リピート率</div>
                <div class="p-4 text-center text-card2-top" v-if="repeatRate == null || repeatRate == ''">-</div>
                <div class="p-4 text-center text-card2-top" v-else>{{ repeatRate }}%</div>
              </div>
            </div>
            <div class="col-md-4 p-3">
              <div style="border: 1px solid #c1c1c1; border-radius: 8px;">
                <div class="p-2 title-card-2">平均顧客単価</div>
                <div class="p-4 text-center text-card2-top" v-if="averagePrice == null || averagePrice == ''">-</div>
                <div class="p-4 text-center text-card2-top" v-else>¥{{ averagePrice | currencyPrice }}</div>
              </div>
            </div>

            <div>
              <div class="col-md-6 p-4">
                <div class="name-chart">男女別割合</div>
                <div v-if="(gender_chart.genders || []).reduce((a, b) => a + b, 0) < 1">データなし</div>
                <GenderChart v-else :width="300" :height="300" ref="genderChart"/>
                <loading
                    :active.sync="gender_chart.isLoading"
                    :is-full-page="fullPage"
                    :color="color"
                    :opacity="opacity"></loading>
              </div>
              <div class="col-md-6 p-4">
                <div class="name-chart">メニュー別割合</div>
                <div v-if="(timeprice_chart.timeprice_data || []).flat().length < 1">データなし</div>
                <TimepriceChart v-else ref="timepriceChart" :width="300" :height="300" />
                <loading
                    :active.sync="timeprice_chart.isLoading"
                    :is-full-page="fullPage"
                    :color="color"
                    :opacity="opacity"></loading>
              </div>
              <div class="col-md-6 p-4">
                <div class="name-chart">エリア別</div>
                <div v-if="(area_chart.area_data && area_chart.area_data.data || []).flat().length < 1">データなし</div>
                <AreaChart v-else ref="areaChart" :width="300" :height="300" />
                <loading
                    :active.sync="area_chart.isLoading"
                    :is-full-page="fullPage"
                    :color="color"
                    :opacity="opacity"></loading>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import RepeatLinenChart from "./analyticCharts/RepeatLinenChart";
import GenderChart from "./analyticCharts/GenderChart"
import TimepriceChart from "./analyticCharts/TimepriceChart";
import AreaChart from "./analyticCharts/AreaChart"
import {mapActions, mapGetters} from "vuex";
export default {
  name: "Analytics",
  computed: {
    ...mapGetters(['startWeekday', 'therapists', 'dataRepeatCharts', 'customerVisted', 'averagePrice', 'repeatRate', 'repeat_chart', 'gender_chart', 'timeprice_chart', 'area_chart'])
  },
  async mounted() {
    await this.fetchTherapists()
    await this.fetchAnalytics()
    await this.repeatLineChart()
    await this.refactorDataRepeat()
  },

  data() {
    return {
      dateStart: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      dateEnd: new Date(),
      ageOptions: [{
        value: null,
        label: ''
      },
      {
        value: 9,
        label: '0~9'
      }, {
        value: 19,
        label: '10~19'
      }, {
        value: 29,
        label: '20~29'
      }, {
        value: 39,
        label: '30~39'
      }, {
        value: 49,
        label: '40~49'
      }, {
        value: 59,
        label: '50~59'
      }, {
        value: 'more-than-60',
        label: '60~'
      }],
      valueCustomer: '',
      valueAge: '',
      numberRepeat: [],
      isActive: false,
      fullPage: false,
      color: '#23CF98',
      opacity: 1,
      repeat_time: '',
      query: {}
    }
  },
  components: {
    RepeatLinenChart, GenderChart, TimepriceChart, AreaChart, Loading
  },
  watch: {
    repeat_chart: {
      handler(newValue, oldValue) {
        this.numberRepeat = (newValue.num_repeats || []).map((e, i) => Object.assign({}, { label: e + "回以上", value: i + 1, active: false }))
        this.numberRepeat.unshift({value: 0, label: "全て", active: false})
        let objIndex = this.numberRepeat.findIndex(e => e.value == this.query.repeat_time)
        if(objIndex != -1) {
          this.numberRepeat[objIndex].active = true
        }
        try {
          this.$refs['lineChart'].renderLineChart();
        } catch(e) { }
      },
      deep: true

    },
    gender_chart: {
      handler(newValue, oldValue) {
        try {
          this.$refs['genderChart'].renderGenderChart();
        } catch(e) { }
      },
      deep: true
    },
    timeprice_chart: {
      handler(newValue, oldValue) {
        try {
          this.$refs['timepriceChart'].renderTimepriceChart()
        } catch(e) {}
      },
      deep: true
    },
    area_chart: {
      handler(newValue, oldValue) {
        try {
          this.$refs['areaChart'].renderAreaChart()
        } catch(e) {}
      },
      deep: true
    }
  },
  methods:{
    ...mapActions('therapist', ['fetchTherapists']),
    ...mapActions('sale_manager_analytic', ['fetchDataAnalytics', 'fetchAnalytics']),
    disableFutureDates(date) {
      return date > new Date()
    },
    fetchAnalytics() {
      let that = this;
      ['repeat_chart', 'gender_chart', 'timeprice_chart', 'area_chart', 'something_else'].forEach(function(context) {
        that.fetchDataAnalytics(Object.assign({}, {dateStart: that.dateStart}, {dateEnd: that.dateEnd}, {therapist_id: that.valueCustomer}, {valueAge: that.valueAge}, {repeat_time: that.repeat_time}, {context: context} ))
      });
    },
    repeatLineChart() {
      if (this.$refs) {
        this.$refs['lineChart'].renderLineChart();
        this.$refs['genderChart'].renderGenderChart();
        this.$refs['timepriceChart'].renderTimepriceChart();
        this.$refs['areaChart'].renderAreaChart();
      }
    },
    selectNumberRepeat(index) {
      this.numberRepeat.map(e => e.active = false)
      let item = this.numberRepeat[index];
      item.active = !item.active;
      this.$set(this.numberRepeat, index, item);
      this.repeat_time = index
      this.query = Object.assign({}, {dateStart: this.dateStart}, {dateEnd: this.dateEnd}, {therapist_id: this.valueCustomer}, {valueAge: this.valueAge}, {repeat_time: this.repeat_time} )
      this.fetchAnalytics(this.query)
    },
    refactorDataRepeat() {
      this.numberRepeat = this.repeat_chart.num_repeats.map((e, index) => Object.assign({}, { value: index + 1, label: e, active: false }))
      this.numberRepeat.unshift({value: 0, label: "全て", active: true})
    },
    checkFilterData() {
      if ( this.dateStart < this.dateEnd ) {
        this.query = Object.assign({}, {dateStart: this.dateStart}, {dateEnd: this.dateEnd}, {therapist_id: this.valueCustomer}, {valueAge: this.valueAge}, {repeat_time: this.repeat_time} )
        this.fetchAnalytics(this.query)
      }
    },
  },
  filters: {
    currencyPrice: function (value) {
      return value.toLocaleString().replace('.',',')
    }
  }
}
</script>


<style lang="scss" scoped>
#analytics-sale-manager {
  .search-date{
    width: 130px;
  }
  .title {
    font-size: 18px;
    color: #7B7670;
    margin-top: 20px;
  }
  .el-card {
    margin-top: 5px;
  }
  .name-chart {
    color: #525252;
    font-size: 18px;
    margin: 15px 0;
    font-family: "HiraginoSans-W5", Helvetica, Arial, serif;
  }
  .title-card-2 {
    border-top-right-radius: 8px;
    color: #1d7831;
    background-color: #e0f1d8;
    border-top-left-radius: 8px;
    font-family: "HiraginoSans-W4", Helvetica, Arial, serif;
  }
  .text-card2-top {
    font-family: "HiraginoSans-W4", Helvetica, Arial, serif;
    font-size: 18px;
  }
  .divider{
    border-bottom: 1px solid #bbb;
    padding-bottom: 4px;
  }
  .shadow-bottom-right {
    box-shadow: 2px 2px #c7c7c7
  }
  .text-number-repeat {
    line-height: 2;
    cursor: pointer;
    padding-left: 20px;
  }
  .text-number-repeat.active {
    background-color: #eeeeee;
    position: relative;
  }
  .text-number-repeat.active:before {
    content: '';
    height: 100%;
    width: 2px;
    background: #60cdcf;
    position: absolute;
    left: 0;
  }
}
</style>

<style lang="scss">
#analytics-sale-manager {
  .el-input__icon {
    display: none;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 5px !important;
  }
  .el-card.shadow-bottom-right.card-number-repeat.is-always-shadow {
    .el-card__body {
      padding: 20px 0;
    }
  }
}
</style>
